<template>
  <div>
    <!-- In questa Row il logo del cliente, se visibile -->
    <!-- usa lo stesso customer_syles definito per la   -->
    <!-- navbar di modo tale da avere gli stessi colori -->
    <b-row v-if="customer_styles.nav_logo.visible">
      <b-col class="pt-3" :style="customer_styles.navbar">
        <b-img center :src="customer_styles.nav_logo.img_logo" class="logo_navbar"></b-img>
      </b-col>
    </b-row>
    <!-- In questa Row la navbar vera e propria -->
    <!-- con le voci di accesso.                -->
    <b-row>
      <b-col>
        <!-- Usiamo colori customizzati e non il set predefinito (dark) -->
        <!-- Per la colorazione delle voci di menù usiamo delle          -->
        <!-- variabili css ( vedi lo style del componente per info )     -->
        <b-navbar id="site-navbar" type="dark" :style="customer_styles.navbar">
          <!-- Nome utente e accesso al profilo -->
          <b-navbar-nav id="navbar-username" class="mr-auto">
            <b-nav-text :style="customer_styles.username">
              <!-- Link alla pagina del profilo visibile solo se siamo nella parte frontoffice -->
              <b-link v-if="show_backoffice_button"
                      :to="{ 'name' : 'user-profile'}"
                      v-b-tooltip.hover.bottomright="'Profilo utente / Impostazioni'"
                      :style="customer_styles.navbar_text_color">
                <font-awesome-icon icon="user-cog"/>
              </b-link>
              {{username}}
            </b-nav-text>
          </b-navbar-nav>
          <!-- Pulsanti notifiche, Conversione Premio, credito residuo e logout -->
          <b-navbar-nav id="navbar-menu-items">
            <!-- Campanella notifiche -->
            <!-- Si basa su di un componente esterno agganciato alle info nello store.      -->
            <!-- E' visibile solo stiamo operando nel frontoffice altrimenti viene nascosta -->
            <b-nav-item v-if="show_backoffice_button">
              <b-link :to="{ name : 'site-notifiche' }">
                <notification-bell
                  id='notification_bell'
                  :size="20"
                  :count="bell_count"
                  counterStyle="roundRectangle"
                  :iconColor="notification_bell_color"
                  :animated="true"
                />
              </b-link>
              <b-tooltip target="notification_bell" triggers="hover">
                <p v-if="bell_count==0">Non ci sono nuove notifiche.</p>
                <p v-else-if="bell_count==1">Hai {{bell_count}} nuova notifica da leggere.</p>
                <p v-else>Hai {{bell_count}} nuove notifiche da leggere.</p>
              </b-tooltip>
            </b-nav-item>
             <!-- Conversione Premio: visibile nel FrontOffice solo se esiste una campagna disponibile per l'utente -->
            <b-nav-item
              v-if="show_backoffice_button && campagna_conversione_premio"
              class="mr-1"
              :style="customer_styles.navbar_text_color"
              @click="apri_conversione_premio"
            >
              Conversione Premio
              <font-awesome-icon icon="gift" class="ml-1"/>
            </b-nav-item>
            <!-- Credito residuo -->
            <!-- E' visibile solo stiamo operando nel frontoffice altrimenti viene nascosto -->
            <b-nav-item v-if="show_backoffice_button" id="credit_icon" class="mr-1" :style="customer_styles.navbar_text_color">
              Il mio credito
              <b-tooltip id="credit-tooltip" target="credit_icon" :triggers="['click']" @show="aggiorna_credito_utente_on_show" placement="bottom">
                <b>Credito attuale:</b>
                <p v-html="cred_residuo_string"></p>
                <b-button @click="open_dash_movimenti" size="sm" variant="light">
                  <font-awesome-icon icon="chart-line"/> Storico movimenti
                </b-button>
              </b-tooltip>
              <font-awesome-icon icon="piggy-bank"/>
            </b-nav-item>
            <!-- Bottoni di navigazione FrontOffice/BackOffice per il referente aziendale -->
            <div v-if="show_ref_azi_buttons">
              <b-nav-item v-if="show_backoffice_button" class="mr-1" @click="goto_backoffice" :style="customer_styles.navbar_text_color">
                Back Office <font-awesome-icon icon="user-tie"/>
              </b-nav-item>
              <b-nav-item v-else class="mr-1" @click="goto_frontoffice" :style="customer_styles.navbar_text_color">
                Front Office <font-awesome-icon icon="store-alt"/>
              </b-nav-item>
            </div>
            <!-- Pulsante LogOut -->
            <b-nav-item @click="logout" class="mr-1" :style="customer_styles.navbar_text_color">Esci <b-icon icon="arrow-bar-right"></b-icon></b-nav-item>
          </b-navbar-nav>
        </b-navbar>
      </b-col>
    </b-row>
    <!-- Banner Conversione Premio: visibile solo fino alla prima scelta del dipendente -->
    <b-container
      v-if="show_backoffice_button && show_conversione_premio_banner"
      fluid
      class="mt-3 mb-3"
    >
      <b-alert show variant="primary" class="mb-0">
        <b-row align-v="center">
          <b-col cols="12" md="8">
            <h5 class="mb-1">
              <font-awesome-icon icon="gift" class="mr-2"/>
              Hai un Premio di Risultato da convertire!
            </h5>
            <p class="mb-2 mb-md-0">
              Scopri le opzioni disponibili e scegli se convertirlo
              in Welfare o riceverlo in busta paga.
            </p>
          </b-col>
          <b-col cols="12" md="4" class="text-md-right mt-2 mt-md-0">
            <b-button
              variant="primary"
              @click="apri_conversione_premio"
            >
              Esprimi la tua scelta
            </b-button>
          </b-col>
        </b-row>
      </b-alert>
    </b-container>
    <!-- Modale per la scelta del premio del dipendente -->
    <CPDipendenteSceltaModal
      v-model="show_conversione_premio_modal"
      :campagna="campagna_conversione_premio"
      @scelta-salvata="show_conversione_premio_banner = false"
    />
  </div>
</template>

<script>
import NotificationBell from 'vue-notification-bell'
import { generalLib } from '@/generalLib'
import { customerStylesMixin } from '@/mixins/customerStylesMixin'
import axios from 'axios'
import { apiUrl } from '@/apiUrl'
import CPDipendenteSceltaModal from "@/components/conversionepremio/CPDipendenteSceltaModal.vue";

export default {
    name: 'SiteNavbar',
    mixins: [ customerStylesMixin ],
    data () {
        return {
            // Flag per visualizzare il pulsante "Back Office"
            // presumiamo qui di essere nella home e quindi
            // far vedere tale pulsante.
            show_backoffice_button : true,

            // Campagna Conversione Premio disponibile per il dipendente.
            // Se null, il pulsante nella navbar rimane nascosto.
            campagna_conversione_premio : null,

            // Gestisce l'apertura della modale per la scelta del dipendente.
            show_conversione_premio_modal : false,

            // Mostra il banner solo quando la campagna è pubblicata
            // e il dipendente non ha ancora effettuato la prima scelta.
            show_conversione_premio_banner : false
        }
    },
    computed : {
        /**
         * Torna la stringa che mostra il credito residuo
         * nel tooltip
         */
        cred_residuo_string : function () {
            let cred_tot = this.$store.state.user.user_credito.totale;
            let art51c3 = this.$store.state.user.user_credito.art51c3;
            let stringa = "Credito Residuo: " + cred_tot + " €<br>" +
                          "di cui ART 51 C.3: " + art51c3 + " €";
            return stringa;
        },
        /**
         * Flag che visualizza i pulsanti di navigazione per il referente
         * aziendale. Quindi controlla che l'utente abbia il profilo da referente
         * e torna true. Altrimenti viene tornato false.
         */
        show_ref_azi_buttons : function () {
            let user_profile = this.$store.state.user.profile;
            return user_profile === 'ref_aziendale' ? true : false;
        },
        /**
         * Un semplice wrapper per la varibile dello store che ci serve visualizzare
         * nella campanella per poter meglio gestire il codice html rendendolo più corto.
         */
        bell_count : function () {
            return this.$store.state.session_infos.notifications.status.ricevuti_new;
        },
        /**
         * Torna il colore della campanella delle notfiche in base alla skin
         * dei colori caricata.
         * Va a controllare il valore "--text-color" nell'attributi "navbar_text_color"
         * se questo non esiste torna il valore predefinito, altrimenti applica il
         * colore definito in "--text-color"
         */
        notification_bell_color: function () {

            let bell_color = "rgba(255,255,255,.5)";

            // L'attributo "navbar_text_color" non deve essere null e non deve essere l'oggetto vuoto
            if ( this.customer_styles.navbar_text_color !== null && this.customer_styles.navbar_text_color !== {} ) {
                // L'attributo "--text-color" deve esistere e non deve essere null
                if ( Object.prototype.hasOwnProperty.call ( this.customer_styles.navbar_text_color, '--text-color' ) &&
                     this.customer_styles.navbar_text_color['--text-color'] !== null ) {
                    bell_color = this.customer_styles.navbar_text_color['--text-color'];
                }
            }

            return bell_color;
        }

    },
    watch : {
        /**
         * Quando vengono caricate le informazioni dell'utente autenticato,
         * verifica se esiste una campagna Conversione Premio disponibile.
         *
         * Il controllo comprende anche il referente aziendale, che può
         * essere destinatario di un premio come dipendente.
         */
        '$store.state.user' : {
            immediate : true,
            handler : function ( user ) {

                // Nasconde il pulsante quando non sono disponibili le informazioni dell'utente.
                if ( !user) {
                    this.campagna_conversione_premio = null;
                    return;
                }
                this.recupera_campagna_conversione_premio();
            }
        }
    },
    methods : {

        /**
        * Apre la modale Conversione Premio per il dipendente.
        */
        apri_conversione_premio () {

            if ( !this.campagna_conversione_premio ) {
               return;
            }

            this.show_conversione_premio_modal = true;
        },

        /**
        * Verifica se il dipendente ha già effettuato una scelta
        * per la campagna Conversione Premio pubblicata.
        *
        * Il banner viene mostrato solo quando non esiste
        * ancora una scelta registrata.
        */
        async verifica_scelta_conversione_premio () {

            this.show_conversione_premio_banner = false;

            if ( !this.campagna_conversione_premio ||
                 this.campagna_conversione_premio.stato !== 'PUBBLICATO' ) {
                return;
            }

            try {

                const response = await axios.get(
                    apiUrl.conversionepremioapi.campagne +
                    this.campagna_conversione_premio.id +
                    '/scelta/'
                );

                this.show_conversione_premio_banner =
                    response.data.scelta === null;

            } catch ( error ) {

                // In caso di errore il banner rimane nascosto.
                console.error(
                    'Errore verifica scelta Conversione Premio:',
                    error
                );
            }
        },

        /**
         * Recupera la campagna Conversione Premio disponibile per il dipendente autenticato.
         * Il backend restituisce prioritariamente una campagna PUBBLICATO, altrimenti la campagna CHIUSO più recente.
         */
        async recupera_campagna_conversione_premio () {

            // Il pulsante e il banner rimangono nascosti finché non viene verificata la disponibilità della campagna.
            this.campagna_conversione_premio = null;
            this.show_conversione_premio_banner = false;

            try {

                const response = await axios.get(
                    apiUrl.conversionepremioapi.dipendente_campagna
                );

                if ( response.data.disponibile && response.data.campagna ) {
                    this.campagna_conversione_premio = response.data.campagna;
                    // Verifica se mostrare il banner per la prima scelta.
                    await this.verifica_scelta_conversione_premio();
                }
                
            } catch ( error ) {

                // In caso di errore il pulsante rimane nascosto.
                console.error(
                    'Errore recupero campagna Conversione Premio:',
                    error
                );

            }
        },

        /**
         * Esegue il logout dell'utente.
         */
        logout : function () {

            // Prendiamo il nome del customer prima di cancellare
            // il contenuto dello store.
            let customer = this.$store.state.customer;

            // Torniamo al login di questo customer, eseguiamo l'effettivo logout
            // cancellando le info utente e settandolo come sloggato solo dopo che
            // il push della route è andata a buon fine.
            // Per richiamare lo store nella funzione ne salviamo il riferimento prima
            // altrimenti non lo troviamo nello scope.
            // Il parametro loggingout = true indica alla route che sto andando al login
            // per sloggarmi, in tal modo il percorso verso il la pagina di login non
            // viene interdetto da router.
            const store_ref = this.$store;
            this.$router.push( { name : 'login', params: { customer: customer, loggingout : true } }, function () {
                // Una volta che il logout è completo possiamo cancellare le
                // info utente in vuex effettuando il logout
                store_ref.dispatch( 'logout' );
            });
        },
        /**
         * Al click sul pulsante "Storico movimenti" apre la dash dei movimenti
         * e chiude il tooltip
         */
        open_dash_movimenti : function () {
            this.$router.push( { name : 'dashmovimenti' } );
            this.$root.$emit('bv::hide::tooltip', 'credit-tooltip');
        },
        /**
         * Associato al bottone di navigazione "Back Office"
         * ci porta al backoffice del referente aziendale e modifica
         * il flag per fare vedere il pulsante "Front Office"
         */
        goto_backoffice : function () {
            this.$router.push( { name : 'home-refazi'} );
            this.show_backoffice_button = false;
        },
        /**
         * Associato al bottone di navigazione "Front Office"
         * ci porta alla home e modifica il flag per fare vedere
         * il pulsante "Back Office"
         */
        goto_frontoffice : function () {
            this.$router.push( { name : 'menu'} );
            this.show_backoffice_button = true;
        },
        /**
         * Wrapper alla funzione aggiorna_credito_utente la quale fa
         * l'update del credito attuale dell'utente.
         * Da chiamare allo onshow del tooltip informativo sul credito.
         */
        aggiorna_credito_utente_on_show : function () {
            generalLib.aggiorna_credito_utente();
        }
    },
    created : function () {
        // Controlliamo il path attuale e se per caso siamo
        // già nella parte backoffice allora settiamo il flag
        // per far vedere il pulsante FrontOffice
        let current_path = this.$router.currentRoute.path;
        if ( current_path.startsWith( "/backoffice-refazi" ) ) {
            this.show_backoffice_button = false;
        }
    },
    props : {
        /**
        * Nome dello user che è loggato
        */
        username: {
            type: String,
            default : ""
        }
    },
    components : {
        NotificationBell,
        CPDipendenteSceltaModal
    }
}
</script>

<style scoped>
#credit_icon {
    cursor: pointer;
}

/* Negli schermi piccoli il logo della navbar,
   se presente, non deve essere più largo di 150px.*/
@media (max-width: 768px) {
    .logo_navbar {
        width: 150px !important;
    }
}

/* Negli schermi piccoli fa in modo che lo username
   ed i bottoni di azione siano uno sopra l'altro */
@media (max-width: 768px) {
  /* Imposta la navbar come un container flexbox
     usando la property flex-dicetion per incolonnare
     gli elementi */
  #site-navbar {
    display: flex;
    flex-direction: column;
  }

  /* Imposta l'ordine degli elementi del flexbox
     in modo che lo username sia sempre sopra i bottoni */
  #navbar-username {
    order: 1;
  }
  #navbar-menu-items {
    order: 2;
  }
}

/* COLORAZIONE DELLE VOCI NELLA BARRA */
/* Per poter raggiungere gli elementi puntualmente si deve agire con il selettore
   css opportuno. Per poter iniettare al suo interno una variabile che definisca il
   colore presa dalla mappatura nella skin usiamo la tecnica delle variabili css.
   Nell'oggetto della skin sono definite le due variabili --text-color e --hover-color
   le quali sono passate tramite l'attributo "style" al css qui sotto, questo
   legge il valore definito nella variabile e lo applica. Se la variabile non è
   trovata si utilizzano i colori di default originali definiti in bootstrap i quali
   sono scritti vicini alle variabili ( rgba(255,255,255,.5) e #fffff ), come valore
   alternativo */

/* ICONA DEL PROFILO UTENTE */
.navbar-dark .navbar-text a {
    color: var(--text-color, rgba(255,255,255,.5) )!important;
}
.navbar-dark .navbar-text a:hover{
    color: var(--hover-color, #ffffff )!important;
}

/* ALTRE VOCI DI MENU' VICINO AL PULSANTE "ESCI" */
.navbar-dark .navbar-nav .nav-link{
    color: var(--text-color, rgba(255,255,255,.5) )!important;
}
.navbar-dark .navbar-nav .nav-link:hover{
    color: var(--hover-color, #ffffff )!important;
}
</style>
